// extracted by mini-css-extract-plugin
module.exports = {"root":"change-password_root__1GBMp","labelCheckBox":"change-password_labelCheckBox__2MQxY"};